<template>
  <div class="stock-custom-query">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 15l3-3-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 12h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="8" cy="8" r="0.5" fill="currentColor"/>
            <circle cx="16" cy="8" r="0.5" fill="currentColor"/>
          </svg>
        </div>
        <h1>自定义查询</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">灵活设定筛选条件，精准发现投资机会</p>
    </div>

    <div class="filter-bar">
      <div class="filter-group">
        <label class="filter-label">交易天数</label>
        <el-input-number
          v-model="queryParams.trading_days"
          :min="50"
          :max="1000"
          :step="50"
          class="number-input"
        ></el-input-number>
      </div>

      <div class="filter-group">
        <label class="filter-label">均价区间</label>
        <div class="range-inputs">
          <el-input-number
            v-model="queryParams.avg_price_min"
            :precision="2"
            :step="1"
            :min="0"
            placeholder="最低"
            class="range-input"
          ></el-input-number>
          <span class="range-separator">-</span>
          <el-input-number
            v-model="queryParams.avg_price_max"
            :precision="2"
            :step="1"
            :min="0"
            placeholder="最高"
            class="range-input"
          ></el-input-number>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">最高价/收盘价 ≥</label>
        <el-input-number
          v-model="queryParams.max_to_close_ratio"
          :precision="2"
          :step="0.1"
          :min="1"
          :max="10"
          class="number-input"
        ></el-input-number>
      </div>

      <div class="filter-group">
        <label class="filter-label">最低价/收盘价区间</label>
        <div class="range-inputs">
          <el-input-number
            v-model="queryParams.min_to_close_ratio_min"
            :precision="2"
            :step="0.05"
            :min="0"
            :max="1"
            placeholder="最低"
            class="range-input"
          ></el-input-number>
          <span class="range-separator">-</span>
          <el-input-number
            v-model="queryParams.min_to_close_ratio_max"
            :precision="2"
            :step="0.05"
            :min="0"
            :max="1"
            placeholder="最高"
            class="range-input"
          ></el-input-number>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">平均换手率(%) ≥</label>
        <el-input-number
          v-model="queryParams.avg_turnover_min"
          :precision="2"
          :step="0.5"
          :min="0"
          :max="100"
          class="number-input"
        ></el-input-number>
      </div>

      <div class="filter-group">
        <label class="filter-label">最高/最低 ≥</label>
        <el-input-number
          v-model="queryParams.max_min_ratio_min"
          :precision="2"
          :step="0.1"
          :min="1"
          :max="10"
          class="number-input"
        ></el-input-number>
      </div>

      <div class="filter-group">
        <label class="filter-label">高点距今(天)</label>
        <div class="range-inputs">
          <el-input-number
            v-model="queryParams.days_since_max_min"
            :precision="0"
            :step="10"
            :min="0"
            :max="1000"
            placeholder="最小"
            class="range-input"
          ></el-input-number>
          <span class="range-separator">-</span>
          <el-input-number
            v-model="queryParams.days_since_max_max"
            :precision="0"
            :step="10"
            :min="0"
            :max="1000"
            placeholder="最大"
            class="range-input"
          ></el-input-number>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">低点距今(天)</label>
        <div class="range-inputs">
          <el-input-number
            v-model="queryParams.days_since_min_min"
            :precision="0"
            :step="10"
            :min="0"
            :max="1000"
            placeholder="最小"
            class="range-input"
          ></el-input-number>
          <span class="range-separator">-</span>
          <el-input-number
            v-model="queryParams.days_since_min_max"
            :precision="0"
            :step="10"
            :min="0"
            :max="1000"
            placeholder="最大"
            class="range-input"
          ></el-input-number>
        </div>
      </div>

      <div class="filter-group">
        <label class="filter-label">主板筛选</label>
        <el-select v-model="queryParams.board_type" class="select-input">
          <el-option label="仅主板" value="main"></el-option>
          <el-option label="全部" value="all"></el-option>
        </el-select>
      </div>

      <div class="button-group">
        <el-button type="primary" @click="fetchData" :loading="loading">
          <i class="el-icon-search"></i>
          查询
        </el-button>
        <el-button @click="resetFilters">
          <i class="el-icon-refresh-left"></i>
          重置
        </el-button>
      </div>
    </div>

    <div class="stock-count">共找到 <strong>{{ stockList.length }}</strong> 只股票</div>

    <el-table
      :data="paginatedStockList"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      class="stock-table"
    >
      <el-table-column prop="code" label="股票代码" width="110">
        <template slot-scope="scope">
          <el-button type="text" @click="viewKLine(scope.row)">
            {{ scope.row.code }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="stock_name" label="股票名称" width="100">
        <template slot-scope="scope">
          {{ scope.row.stock_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="latest_close" label="最新收盘价" width="100" align="right">
        <template slot-scope="scope">
          {{ scope.row.latest_close || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="avg_close" label="300日均价" width="100" align="right">
        <template slot-scope="scope">
          {{ scope.row.avg_close || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="max_high" label="300日最高" width="100" align="right">
        <template slot-scope="scope">
          <span class="value-high">
            {{ scope.row.max_high || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="min_low" label="300日最低" width="100" align="right">
        <template slot-scope="scope">
          <span class="value-low">
            {{ scope.row.min_low || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="max_to_close_ratio" label="最高/收盘(%)" width="120" align="right">
        <template slot-scope="scope">
          <span :class="getRatioClass(scope.row.max_to_close_ratio, 150)">
            {{ scope.row.max_to_close_ratio || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="min_to_close_ratio" label="最低/收盘(%)" width="120" align="right">
        <template slot-scope="scope">
          <span :class="getRatioClass(scope.row.min_to_close_ratio, 90, true)">
            {{ scope.row.min_to_close_ratio || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="avg_turnover_rate" label="平均换手率(%)" width="120" align="right">
        <template slot-scope="scope">
          <span :class="getTurnoverClass(scope.row.avg_turnover_rate)">
            {{ scope.row.avg_turnover_rate || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="max_min_ratio" label="最高/最低" width="110" align="right">
        <template slot-scope="scope">
          <span :class="getMaxMinRatioClass(scope.row.max_min_ratio)">
            {{ scope.row.max_min_ratio ? parseFloat(scope.row.max_min_ratio).toFixed(2) : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="days_since_max" label="高点距今(天)" width="110" align="right">
        <template slot-scope="scope">
          <span :class="getDaysSinceMaxClass(scope.row.days_since_max)">
            {{ scope.row.days_since_max || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="days_since_min" label="低点距今(天)" width="110" align="right">
        <template slot-scope="scope">
          <span :class="getDaysSinceMinClass(scope.row.days_since_min)">
            {{ scope.row.days_since_min || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click.stop="viewKLine(scope.row, 'day')"
          >
            日K
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click.stop="viewKLine(scope.row, 'week')"
          >
            周K
          </el-button>
          <el-button
            type="text"
            size="mini"
            :loading="scope.row.adding"
            @click.stop="addToFavorite(scope.row)"
          >
            自选
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click.stop="copyStockCode(scope.row)"
          >
            复制
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="stockList.length > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="stockList.length"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StockCustomQuery',
  data() {
    return {
      queryParams: {
        trading_days: 300,
        avg_price_min: 3,
        avg_price_max: 50,
        max_to_close_ratio: 1.5,
        min_to_close_ratio_min: 0.8,
        min_to_close_ratio_max: 0.9,
        avg_turnover_min: 1,
        max_min_ratio_min: 1.5,
        days_since_max_min: 0,
        days_since_max_max: 500,
        days_since_min_min: 0,
        days_since_min_max: 500,
        board_type: 'main'
      },
      stockList: [],
      loading: false,
      currentPage: 1,
      pageSize: 50,
      userId: '1'
    }
  },
  computed: {
    paginatedStockList() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.stockList.slice(start, end)
    }
  },
  mounted() {
    // 页面加载时不自动查询，等待用户手动触发
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const response = await axios.get('/stock/custom/query', {
          params: this.queryParams
        })

        if (response.data.status === 'success') {
          this.stockList = response.data.data
          this.currentPage = 1
          if (this.stockList.length === 0) {
            this.$message.info({
              message: '未找到符合条件的股票',
              duration: 3000
            })
          }
        } else {
          this.$message.error({
            message: response.data.message || '查询失败',
            duration: 3000
          })
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error({
          message: '查询失败: ' + (error.response?.data?.message || error.message),
          duration: 3000
        })
      } finally {
        this.loading = false
      }
    },

    resetFilters() {
      this.queryParams = {
        trading_days: 300,
        avg_price_min: 3,
        avg_price_max: 50,
        max_to_close_ratio: 1.5,
        min_to_close_ratio_min: 0.8,
        min_to_close_ratio_max: 0.9,
        avg_turnover_min: 1,
        max_min_ratio_min: 1.5,
        days_since_max_min: 0,
        days_since_max_max: 500,
        days_since_min_min: 0,
        days_since_min_max: 500,
        board_type: 'main'
      }
      this.fetchData()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },

    handleCurrentChange(val) {
      this.currentPage = val
    },

    getRatioClass(value, threshold, isLower = false) {
      if (!value) return ''
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return ''
      if (isLower) {
        // 最低价比率，越低越好
        if (numValue <= threshold * 0.8) return 'value-strong-positive'
        if (numValue <= threshold * 0.9) return 'value-positive'
        return 'value-neutral'
      } else {
        // 最高价比率，越高越好
        if (numValue >= threshold * 1.5) return 'value-strong-positive'
        if (numValue >= threshold * 1.3) return 'value-positive'
        return 'value-neutral'
      }
    },

    getTurnoverClass(value) {
      if (!value) return ''
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return ''
      if (numValue >= 5) return 'turnover-very-high'
      if (numValue >= 3) return 'turnover-high'
      if (numValue >= 1) return 'turnover-normal'
      return 'turnover-low'
    },

    getDaysSinceMaxClass(value) {
      if (!value) return ''
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return ''
      // 高点距今时间越长越好（可能处于低位）
      if (numValue >= 180) return 'days-very-long'
      if (numValue >= 90) return 'days-long'
      if (numValue >= 30) return 'days-medium'
      return 'days-short'
    },

    getDaysSinceMinClass(value) {
      if (!value) return ''
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return ''
      // 低点距今时间，越短越好（可能处于上升趋势）
      if (numValue <= 30) return 'days-min-very-short'
      if (numValue <= 60) return 'days-min-short'
      if (numValue <= 90) return 'days-min-medium'
      return 'days-min-long'
    },

    getMaxMinRatioClass(value) {
      if (!value) return ''
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return ''
      // 最高/最低比，越高表示波动越大
      if (numValue >= 2.5) return 'ratio-very-high'
      if (numValue >= 2.0) return 'ratio-high'
      if (numValue >= 1.5) return 'ratio-medium'
      return 'ratio-normal'
    },

    viewKLine(row, type = 'day') {
      const routeMap = {
        'day': '/kline/day',
        'week': '/kline/week',
        '5min': '/kline/5min'
      }
      this.$router.push({
        path: routeMap[type],
        query: { code: row.code }
      })
    },

    async addToFavorite(row) {
      this.$set(row, 'adding', true)
      try {
        const response = await axios.post('/stock/favorite/add', {
          user_id: this.userId,
          stock_code: row.code,
          stock_name: row.stock_name,
          remark: '',
          sort_order: 0
        })
        if (response.data.status === 'success') {
          this.$message.success({
            message: `已将 ${row.stock_name || row.code} 添加到自选`,
            duration: 3000
          })
        } else {
          this.$message.error({
            message: response.data.message || '添加失败',
            duration: 3000
          })
        }
      } catch (error) {
        console.error('添加自选失败:', error)
        this.$message.error({
          message: '添加自选失败: ' + (error.response?.data?.message || error.message),
          duration: 3000
        })
      } finally {
        this.$set(row, 'adding', false)
      }
    },

    copyStockCode(row) {
      const code = row.code
      navigator.clipboard.writeText(code).then(() => {
        this.$message.success({
          message: `已复制: ${code}`,
          duration: 2000
        })
      }).catch(err => {
        console.error('复制失败:', err)
        this.$message.error({
          message: '复制失败',
          duration: 2000
        })
      })
    }
  }
}
</script>

<style scoped>
.stock-custom-query {
  padding: 24px;
  min-height: calc(100vh - 64px);
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin-bottom: 32px;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
}

.title-icon svg {
  width: 28px;
  height: 28px;
}

.page-title h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-decoration {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  letter-spacing: 0.5px;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  gap: 20px;
  align-items: flex-end;
  margin-bottom: 24px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.number-input {
  width: 140px;
}

.select-input {
  width: 140px;
}

.range-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-input {
  width: 125px;
}

.range-separator {
  color: #64748b;
  font-weight: 500;
}

.button-group {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

/* 输入框样式 */
.filter-bar :deep(.el-input__inner) {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(236, 72, 153, 0.2) !important;
  color: #e2e8f0 !important;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* 确保el-input-number组件正确显示 - Element UI Vue 2版本 */
.filter-bar :deep(.el-input-number) {
  width: 140px;
  display: inline-block;
  position: relative;
  height: 38px;
}

.filter-bar :deep(.el-input-number .el-input__inner) {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  color: #e2e8f0 !important;
  border-radius: 8px;
  text-align: left;
  padding: 0 45px 0 12px;
  transition: all 0.3s ease;
  width: 100%;
  height: 38px;
  line-height: 38px;
}

.filter-bar :deep(.el-input-number .el-input-number__decrease),
.filter-bar :deep(.el-input-number .el-input-number__increase) {
  background: rgba(15, 23, 42, 0.8) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  color: #a5b4fc !important;
  width: 34px;
  height: 17px;
  line-height: 15px;
  position: absolute;
  right: 2px;
  z-index: 1;
}

.filter-bar :deep(.el-input-number .el-input-number__decrease) {
  top: 2px;
  border-top-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.filter-bar :deep(.el-input-number .el-input-number__increase) {
  bottom: 2px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 6px;
  border-top: none;
}

.filter-bar :deep(.el-input-number .el-input-number__decrease:hover),
.filter-bar :deep(.el-input-number .el-input-number__increase:hover) {
  color: #818cf8 !important;
  background: rgba(99, 102, 241, 0.15) !important;
}

.filter-bar :deep(.el-input-number:hover .el-input__inner) {
  border-color: rgba(99, 102, 241, 0.4) !important;
}

.filter-bar :deep(.el-input-number.is-focused .el-input__inner) {
  border-color: #6366f1 !important;
}

.filter-bar :deep(.el-input__inner:hover) {
  border-color: rgba(99, 102, 241, 0.4) !important;
}

.filter-bar :deep(.el-input__inner:focus) {
  border-color: #6366f1 !important;
}

.filter-bar :deep(.el-select .el-input__inner) {
  cursor: pointer;
}

.filter-bar :deep(.el-select:hover .el-input__inner) {
  border-color: rgba(99, 102, 241, 0.4) !important;
}

/* range-input 特殊样式 */
.filter-bar :deep(.range-input.el-input-number) {
  width: 125px;
}

.filter-bar :deep(.range-input.el-input-number .el-input__inner) {
  padding: 0 45px 0 12px;
}

/* 股票数量 */
.stock-count {
  margin-bottom: 16px;
  font-size: 14px;
  color: #94a3b8;
}

.stock-count strong {
  color: #a5b4fc;
  font-size: 16px;
}

/* 表格样式 */
.stock-table {
  background: rgba(30, 41, 59, 0.6);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(99, 102, 241, 0.15);
  border-radius: 12px;
  overflow: hidden;
}

.stock-table :deep(.el-table__header-wrapper) {
  background: rgba(15, 23, 42, 0.5);
}

.stock-table :deep(th.el-table__cell) {
  background: rgba(15, 23, 42, 0.8) !important;
  color: #a5b4fc;
  font-weight: 600;
  border-bottom: 1px solid rgba(99, 102, 241, 0.15);
}

.stock-table :deep(td.el-table__cell) {
  border-bottom: 1px solid rgba(99, 102, 241, 0.1);
}

.stock-table :deep(.el-table__row) {
  background: rgba(30, 41, 59, 0.3);
}

.stock-table :deep(.el-table__row:hover td) {
  background: rgba(99, 102, 241, 0.1) !important;
}

/* 操作列居中 */
.stock-table :deep(.el-table__cell.el-table__cell) {
  text-align: center;
}

.stock-table :deep(.el-table__body td.el-table__cell) {
  text-align: center;
}

/* 数值样式 */
.value-high {
  color: #22c55e;
  font-weight: 600;
}

.value-low {
  color: #ef4444;
  font-weight: 600;
}

.value-strong-positive {
  color: #22c55e;
  font-weight: 700;
}

.value-positive {
  color: #4ade80;
  font-weight: 600;
}

.value-neutral {
  color: #94a3b8;
}

/* 换手率样式 */
.turnover-very-high {
  color: #ef4444;
  font-weight: 700;
}

.turnover-high {
  color: #f97316;
  font-weight: 600;
}

.turnover-normal {
  color: #fbbf24;
  font-weight: 600;
}

.turnover-low {
  color: #94a3b8;
}

/* 高点距今天数样式 */
.days-very-long {
  color: #22c55e;
  font-weight: 700;
}

.days-long {
  color: #4ade80;
  font-weight: 600;
}

.days-medium {
  color: #fbbf24;
  font-weight: 600;
}

.days-short {
  color: #94a3b8;
}

/* 低点距今天数样式 */
.days-min-very-short {
  color: #22c55e;
  font-weight: 700;
}

.days-min-short {
  color: #4ade80;
  font-weight: 600;
}

.days-min-medium {
  color: #fbbf24;
  font-weight: 600;
}

.days-min-long {
  color: #94a3b8;
}

/* 最高最低比样式 */
.ratio-very-high {
  color: #ef4444;
  font-weight: 700;
}

.ratio-high {
  color: #f97316;
  font-weight: 600;
}

.ratio-medium {
  color: #fbbf24;
  font-weight: 600;
}

.ratio-normal {
  color: #94a3b8;
}

/* 分页 */
.pagination {
  margin-top: 20px;
  text-align: center;
}

.pagination :deep(.el-pagination) {
  color: #94a3b8;
}

.pagination :deep(.el-pagination .el-pager li) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  margin: 0 4px;
  min-width: 32px;
  height: 32px;
  line-height: 30px;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination .el-pager li:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.pagination :deep(.el-pagination .el-pager li.active) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: transparent;
  color: #ffffff;
  font-weight: 600;
}

.pagination :deep(.el-pagination button) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #94a3b8;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination button:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}
</style>
